"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalGradient = void 0;
exports.GradientButton = GradientButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const native_base_1 = require("native-base");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_linear_gradient_1 = __importDefault(require("react-native-linear-gradient"));
const colors_1 = require("../../common/colors");
const theme_1 = require("../../helper/theme");
const AppText_1 = require("../AppText");
var HorizontalGradient_1 = require("./HorizontalGradient");
Object.defineProperty(exports, "HorizontalGradient", { enumerable: true, get: function () { return __importDefault(HorizontalGradient_1).default; } });
function GradientButton({ text, iconOnly, customStyles, customGradientColors, disabled, loading, onPress, paddingH = react_native_1.Platform.OS === 'web' ? undefined : 5, fullWidth = true, variant = "filled", loadingText = 'Please wait', style, ...restProps }) {
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsx)(react_native_1.Pressable, { onPress: onPress, disabled: disabled ? disabled : false, style: [{
                paddingHorizontal: paddingH,
                ...(fullWidth && { width: "100%" }),
            }, style], accessible: true, accessibilityLabel: typeof text === 'string' ? text : '', onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false), ...restProps, children: (0, jsx_runtime_1.jsxs)(react_native_linear_gradient_1.default, { start: { x: 0, y: 0 }, end: { x: 0, y: 1 }, colors: disabled && react_native_1.Platform.OS === 'web' && ["#2A2A2F", "#2A2A2F"] ||
                variant === "warning" && colors_1.Colors.GRADIENT_WARNING || customGradientColors || colors_1.Colors.GRADIENT, style: [
                styles.linearGradient,
                iconOnly && { height: 'auto' },
                { minWidth: fullWidth ? 300 : 0 },
                customStyles?.button,
                isHovered && styles.hoveredButton,
            ], children: [(react_native_1.Platform.OS === 'web' && !loading || !disabled && react_native_1.Platform.OS !== 'web') && (typeof text === 'string' ? ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: disabled ? colors_1.Colors.DARK_400 : 'white', style: [styles.linearGradientText, customStyles?.text], numberOfLines: 1, lineBreakMode: "tail", allowFontScaling: true, fontSize: (0, theme_1.normalize)(16), fontWeight: 500, lineHeight: (0, theme_1.normalize)(20), children: text })) : (text)), loading && ((0, jsx_runtime_1.jsxs)(native_base_1.HStack, { space: 2, justifyContent: "center", style: [styles.linearGradientText, customStyles?.text], children: [(0, jsx_runtime_1.jsx)(native_base_1.Spinner, { accessibilityLabel: "Loading posts", color: colors_1.Colors.white }), (0, jsx_runtime_1.jsx)(native_base_1.Heading, { color: colors_1.Colors.white, fontSize: "md", children: loadingText })] }))] }) }));
}
const styles = react_native_1.StyleSheet.create({
    linearGradient: {
        display: "flex",
        justifyContent: 'center',
        height: 52,
        padding: 8,
        borderRadius: 64,
    },
    linearGradientText: {
        textAlign: "center",
        margin: 0,
        fontSize: 16,
    },
    hoveredButton: {
        opacity: 0.8,
    },
});
